import { createSlice } from "@reduxjs/toolkit";
import { EnrollmentResponseDto } from "../../shared/dtos/enrollment/EnrollmentResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const enrollmentSlice = createSlice({
  name: "enrollment",
  initialState: getInitialCrudState<EnrollmentResponseDto>(),
  reducers: {
    ...generateCrudReducers<EnrollmentResponseDto>(),
  },
});

export const enrollmentActions = enrollmentSlice.actions;
export default enrollmentSlice.reducer;
